import { render, staticRenderFns } from "./AddMeasureTaskDialog.vue?vue&type=template&id=2371df01&scoped=true&"
import script from "./AddMeasureTaskDialog.vue?vue&type=script&lang=js&"
export * from "./AddMeasureTaskDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2371df01",
  null
  
)

export default component.exports